import { defineMessages } from '@approvalmax/utils';

export const messages = defineMessages('app.ProfileSetup.FormSectionQualificationQuestions', {
    title: 'Please describe your company',
    companyPartner: 'Accounting / Bookkeeping practice',
    companyBusiness: 'A business / Non-Profit organization',
    partnerStatusPlaceholder: 'Accounting platform or cloud partner status',
    numberOfClientsPlaceholder: 'Select the number of clients you have',
    productInterestPlaceholder: 'Select your accounting platform',
    numberOfEntitiesPlaceholder: 'Select the number of entities in your company',
    useCasePlaceholder: 'Choose the reasons for using ApprovalMax',
    selectedCount: '{count} selected',
});
